/** @jsx jsx */
import { jsx, Themed } from 'theme-ui';
import Figure from './Figure';
import Gallery from './Gallery';
import { useLangKey } from '../../utils/lang';

//import FigureWide from 'gatsby-theme-catalyst-sanity/src/components/sanity/figure-wide';
//import Code from 'gatsby-theme-catalyst-sanity/src/components/sanity/code';
import React from 'react';
import More from '../more';
import { useHoverState } from '../MoreHoverContext';
import Video from './Video';
import { useShowMember } from '../playinfo-page/ShowMemberContext';
import { MemberLink } from '../playinfo-page/MemberLink';
import { Link } from 'gatsby'
const headerId = (id) => {
	return id.toString().toLowerCase().replace(/(^\s+|[^a-zA-Z0-9 ]+|\s+$)/g, '').replace(/\s+/g, '-');
};

const Dots = () => {
	const hover = useHoverState();
	return <span sx={{ color: !hover ? '#00f' : '#ff6c3f', fontSize: 5, lineHeight: '0.5em' }}>... </span>;
};

const serializers = {
	list: (props) => {
		const { type } = props;
		const bullet = type === 'bullet';
		if (bullet) {
			return <Themed.ul>{props.children}</Themed.ul>;
		}
		return <Themed.ol>{props.children}</Themed.ol>;
	},

	listItem: (props) => <Themed.li>{props.children}</Themed.li>,

	types: {
		//code: Code,
		figure: Figure,
		gallery: Gallery,
		videoWithImage: Video,

		//figureWide: FigureWide,
		block(props) {
			switch (props.node.style) {
				case 'h1':
					return <Themed.h1 id={headerId(props.children)}>{props.children}</Themed.h1>;
				case 'h2':
					return <Themed.h2 id={headerId(props.children)}>{props.children}</Themed.h2>;
				case 'h3':
					return <Themed.h3 id={headerId(props.children)}>{props.children}</Themed.h3>;
				case 'h4':
					return <Themed.h4 id={headerId(props.children)}>{props.children}</Themed.h4>;
				case 'h5':
					return <Themed.h5 id={headerId(props.children)}>{props.children}</Themed.h5>;
				case 'h6':
					return <Themed.h6 id={headerId(props.children)}>{props.children}</Themed.h6>;
				case 'small':
					return <Themed.p sx={{ fontSize: 1 }}>{props.children}</Themed.p>;
				case 'smallest':
					return <Themed.p sx={{ fontSize: 0 }}>{props.children}</Themed.p>;
				case 'blockquote':
					return <Themed.blockquote>{props.children}</Themed.blockquote>;
				default:
					return <Themed.p>{props.children}</Themed.p>;
			}
		}
	},
	marks: {
		last: ({ children }) => (
			<React.Fragment>
				{children}
				<div sx={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
					{' '}
					<Dots />
					<More
						msx={{
							textShadow: '0 -1px 0 #00f, 0 1px 0 #00f, 1px 0 0 #00f, -1px 0 0 #00f, -4px 2px 0 #00f'
						}}
					/>
				</div>
			</React.Fragment>
		),
		sup: ({ children }) => <sup>{children}</sup>,
		code: ({ children }) => <Themed.inlineCode>{children}</Themed.inlineCode>,
		link: ({ children, mark }) =>
			mark.blank ? (
				<Themed.a href={mark.href} target="_blank" rel="noopener noreferer">
					{children}
				</Themed.a>
			) : (
				<Themed.a href={mark.href}>{children}</Themed.a>
			),
		memberLink: ({ children, mark }) => {
			if (mark.reference?.flower || mark.reference?.bioSlug) {
				const member = { content: mark.reference, bioSlug: mark.reference?.bioSlug }
				return <MemberLink member={member}>{children}</MemberLink>;
			}
			return <span>{children}</span>;
		}
		// mark.reference ? (
		// 	<MemberLink member={mark.reference}>
		// 		{children}
		// 	</MemberLink>
		// ) : (<React.Fragment>aefeafe {children[0]}</React.Fragment>)
	}
};

export const BioLink = ({ member, children }) => {
	const langKey = useLangKey();
	return <Link sx={{
		textDecoration: 'none',
		color: 'inherit',
		fontWeight: 800, cursor: 'pointer', ':hover': {
			color: '#ff6c3f'
		},
		':visited': {
			color: 'inherit'
		}
	}
	} to={`/${langKey}/bio/${member.bioSlug}`}> {children}</Link >;
}

export const serializersExcerpt = {
	...serializers,
	types: {
		//code: Code,
		//figure: Figure,

		//figureWide: FigureWide,
		block(props) {
			switch (props.node.style) {
				case 'h1':
					return <Themed.h1 id={headerId(props.children)}>{props.children}</Themed.h1>;
				case 'h2':
					return <Themed.h2 id={headerId(props.children)}>{props.children}</Themed.h2>;
				case 'h3':
					return <Themed.h3 id={headerId(props.children)}>{props.children}</Themed.h3>;
				case 'h4':
					return <Themed.h4 id={headerId(props.children)}>{props.children}</Themed.h4>;
				case 'h5':
					return <Themed.h5 id={headerId(props.children)}>{props.children}</Themed.h5>;
				case 'h6':
					return <Themed.h6 id={headerId(props.children)}>{props.children}</Themed.h6>;
				case 'small':
					return <Themed.p sx={{ fontSize: 1, my: 0 }}>{props.children}</Themed.p>;
				case 'smallest':
					return <Themed.p sx={{ fontSize: 0, my: 0 }}>{props.children}</Themed.p>;
				case 'blockquote':
					return <Themed.blockquote>{props.children}</Themed.blockquote>;
				default:
					return <Themed.p sx={{ my: 0 }}>{props.children}</Themed.p>;
			}
		}
	}
};

export default serializers;
